export enum TrendDialogMode {
    IMPROVEMENT,
    SCORECARD,
    INSIGHT_TREND,
    MI2,
}
